import type { JSX } from "react";
import { createFileRoute, useParams, useRouter, useSearch } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { useGraphQL } from "@/hooks/use-graphql.ts";
import { CheckoutDetails } from "@/components/payment/details/checkout-details";

const PaymentBillingGroupPageQuery = graphql(`
  query PaymentBillingGroupPageQuery($billingIdGroup: Int!) {
    billing: cobrancasAgrupadas(codUsuarioCobrancaAgrupada: $billingIdGroup) {
      ...CheckoutDetailsFragment
    }
  }
`);

const PaymentBillingGroup = (): JSX.Element => {
  const { billingIdGroup } = useParams({
    from: "/settings/billing/details/paymentBillingGroup/$billingIdGroup/",
  });

  const parsedBillingId = Number(billingIdGroup);

  const params: { from?: string } = useSearch({ strict: false });
  const router = useRouter();
  const handleGoBack = (): void => {
    if (params.from === "billing-actions") {
      router.history.go(-2);
      return;
    }

    router.history.back();
  };

  const queryData = useGraphQL(
    PaymentBillingGroupPageQuery,
    {
      billingIdGroup: parsedBillingId,
    },
    {
      refetchInterval: 3 * 60 * 1000, // 1 minute
    },
  );

  const { data } = queryData;
  const billing = data?.billing;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" onClick={handleGoBack} />
        <HeaderTitle title="Pagamento" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryData}>
          {billing ? <CheckoutDetails data={billing} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/billing/details/paymentBillingGroup/$billingIdGroup/",
)({
  component: PaymentBillingGroup,
});
